import { createContext } from 'react';

export const VendaContext = createContext({
  venda: {
    cliente: null,
    itens: [],
    vendaId: -1,
    itensEstoque: [],
  },
  dispatch: () => {},
});
